import store from '../store'
import {getToken} from '../helpers/token'
import SockJS from 'sockjs-client'
import {Client as StompClient} from '@stomp/stompjs'

const stompClient = new StompClient({
  // debug: function (str) {
  //   console.log(str);
  // },
  reconnectDelay: 5000,
  heartbeatIncoming: 4000,
  heartbeatOutgoing: 4000
});
const endpoint = process.env.NODE_ENV === 'development' ? 'https://adgame-test.vse.cz/ws' : `${location.origin}/ws`

stompClient.webSocketFactory = function () {
  return new SockJS(endpoint);
}
stompClient.subscribedTo = []

function dispatchSocket(frame) {
  const {msgType, payload} = JSON.parse(frame.body)
  if (process.env.NODE_ENV === 'development') {
    console.log(`%c SOCKET_${msgType}`, 'background: #0D0208; color:  #00FF41', payload);
  }
  store.dispatch(`SOCKET_${msgType}`, payload)
}

async function subscribe(path) {
  if (!stompClient.subscribedTo.find(item => item.path === path)) {
    const result = await stompClient.subscribe(path, dispatchSocket);

    stompClient.subscribedTo.push({
      ...result,
      path
    })
  }
}

const stompSocket = {
  stompClient,
  connect: () => {
    if (!stompClient.connected) {
      stompClient.connectHeaders = {token: getToken(false)}
      stompClient.activate()
    }
  },
  waitForConnection: async () => {
    return new Promise((resolve) => {
      if (stompClient.connected) {
        resolve()
      } else {
        stompClient.onConnect = resolve
      }
    })
  },
  disconnect: () => {
    stompClient.deactivate()
  },
  subscribeGame: (gameId) => {
    subscribe(`/game/${gameId}`)
  },
  subscribeTeam: (teamId) => {
    subscribe(`/team/${teamId}`)
  },
  subscribeHome: () => {
    subscribe(`/home`)
  },
  unsubscribe() {
    stompClient.subscribedTo.forEach(function(item){
      item.unsubscribe()
    });
    stompClient.subscribedTo = []
  },
  checkConnected() {
    console.log("Všechny připojené sockety:")
    console.log(stompClient.subscribedTo)
  }
}



if (getToken()) {
  stompSocket.connect()
}

export default stompSocket
